import type { ActionCard } from '@shared/definitions/action-card.model';

/**
 * The cockpit's free-text search, in ONE place (#257).
 *
 * It used to live in three: the Firestore store, the demo store and the feed
 * component each carried their own copy of the same four-field predicate, with
 * a comment in the third saying it mirrored the first. Adding a field to one
 * of them — which is exactly what this issue does — would have made the flux
 * and the store disagree about what "matches" means.
 *
 * `sourceBody` joins the haystack here: the owner searching for an amount or a
 * sentence they remember reading was getting nothing, because the body was the
 * one thing never looked at. It is always present on the card (no extra fetch),
 * so the cost is a longer string to lowercase, not a round-trip.
 *
 * What this does NOT do is widen WHICH cards are looked at: the predicate is
 * applied to whatever the caller already holds. The archive stays a deliberate,
 * bounded, on-demand load.
 */
export function matchesCardSearch(card: ActionCard, term: string): boolean {
  const q = term.trim().toLowerCase();
  if (!q) return true;
  return [
    card.subject,
    card.senderName,
    card.extraction?.summary,
    card.classification?.propertyLabel,
    card.sourceBody,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase()
    .includes(q);
}
